/* eslint-disable */
export default {
  inAMeeting: 'In a meeting',
  onMyWay: 'On my way',
  callMeBackIn: 'Call me back in...',
  willCallYouBackIn: 'Will call you back in...',
  hour: 'hour',
  min: 'min',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
